import { createToolStore } from './create-tool-store'

export const useConverterStore = createToolStore({ quality: 80 })
